/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Tab_CasesInputs */

const en_client_tab_cases = /** @type {(inputs: Client_Tab_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

const pt_br2_client_tab_cases = /** @type {(inputs: Client_Tab_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos`)
};

/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Client_Tab_CasesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_tab_cases = /** @type {((inputs?: Client_Tab_CasesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Tab_CasesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_tab_cases(inputs)
	return pt_br2_client_tab_cases(inputs)
});